<template>
  <div class="collection">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :max-height="tableHeight"
      :columns="columnList"
      show-footer
      :footer-method="footerMethod"
      column-min-width="120"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import fullScreenDialog from '@/common/mixins/fullScreenDialog.js';
  export default {
    mixins: [fullScreenDialog],
    name: 'collection',
    computed: {
      columnList() {
        return [
          { type: 'seq', width: 60, title: this.$t('table.index'), fixed: 'left' }, // 序号
          {
            field: 'serializationJsonData.contractNo',
            title: this.$t('batchAdd.collection.contractNo'),
          }, // 销售管理号
          {
            field: 'serializationJsonData.registerDate',
            title: this.$t('batchAdd.collection.registerDate'),
          }, // 收款日期
          {
            // 收款金额
            field: 'serializationJsonData.originReceiveMoneyAmount',
            title: this.$t('batchAdd.collection.originReceiveMoneyAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.originReceiveMoneyAmount
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            field: 'serializationJsonData.payerName',
            title: this.$t('batchAdd.collection.payerName'),
          }, // 付款单位
          { field: 'serializationJsonData.mark', title: this.$t('batchAdd.collection.mark') },
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {
      footerMethod({ columns, data }) {
        let returnProps = ['serializationJsonData.originReceiveMoneyAmount'];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (returnProps.includes(column.property)) {
              let subtrahend = 0;
              data.map((item) => {
                subtrahend = this.$cal.calCommon(
                  item.serializationJsonData[column.property.replace('serializationJsonData.', '')],
                  subtrahend,
                  '+'
                );
              });
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
        ];
      },
    },
  };
</script>
